import * as loc from '../../messages';
/**
 * @hidden
 */
export var textFilterOperators = [
    { text: loc.filterContainsOperator, operator: 'contains' },
    { text: loc.filterNotContainsOperator, operator: 'doesnotcontain' },
    { text: loc.filterEqOperator, operator: 'eq' },
    { text: loc.filterNotEqOperator, operator: 'neq' },
    { text: loc.filterStartsWithOperator, operator: 'startswith' },
    { text: loc.filterEndsWithOperator, operator: 'endswith' },
    { text: loc.filterIsNullOperator, operator: 'isnull' },
    { text: loc.filterIsNotNullOperator, operator: 'isnotnull' },
    { text: loc.filterIsEmptyOperator, operator: 'isempty' },
    { text: loc.filterIsNotEmptyOperator, operator: 'isnotempty' }
];
/**
 * @hidden
 */
export var numericFilterOperators = [
    { text: loc.filterEqOperator, operator: 'eq' },
    { text: loc.filterNotEqOperator, operator: 'neq' },
    { text: loc.filterGteOperator, operator: 'gte' },
    { text: loc.filterGtOperator, operator: 'gt' },
    { text: loc.filterLteOperator, operator: 'lte' },
    { text: loc.filterLtOperator, operator: 'lt' },
    { text: loc.filterIsNullOperator, operator: 'isnull' },
    { text: loc.filterIsNotNullOperator, operator: 'isnotnull' }
];
/**
 * @hidden
 */
export var dateFilterOperators = [
    { text: loc.filterEqOperator, operator: 'eq' },
    { text: loc.filterNotEqOperator, operator: 'neq' },
    { text: loc.filterAfterOrEqualOperator, operator: 'gte' },
    { text: loc.filterAfterOperator, operator: 'gt' },
    { text: loc.filterBeforeOperator, operator: 'lt' },
    { text: loc.filterBeforeOrEqualOperator, operator: 'lte' },
    { text: loc.filterIsNullOperator, operator: 'isnull' },
    { text: loc.filterIsNotNullOperator, operator: 'isnotnull' }
];
/**
 * @hidden
 */
export var booleanOperator = 'eq';
/**
 * @hidden
 */
export var booleanFilterValues = [
    { text: loc.filterBooleanAll, operator: '' },
    { text: loc.filterIsTrue, operator: true },
    { text: loc.filterIsFalse, operator: false }
];
/**
 * @hidden
 */
export function localizeFilter(localization, operators) {
    return {
        clearButtonTitle: localization.toLanguageString(loc.filterClearButton, loc.messages[loc.filterClearButton]),
        operators: operators.map(function (o) { return ({
            text: localization.toLanguageString(o.text, loc.messages[o.text]),
            operator: o.operator
        }); })
    };
}
